// extracted by css-extract-rspack-plugin
export default {"tooltipWrapper":"ReviewSummaryRating-module__tooltipWrapper","hasHoverSummary":"ReviewSummaryRating-module__hasHoverSummary","tooltip":"ReviewSummaryRating-module__tooltip"};